
















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Engine, {
  BoardAction as BoardActionEnum,
  boardActions,
  Command,
  factionPlanet,
  Planet,
  PlayerEnum, Reward,
} from "@gaia-project/engine";
import Resource from "./Resource.vue";
import SpecialAction from "./SpecialAction.vue";
import { boardActionButton } from "../logic/buttons/actions";
import { enabledButtonWarnings } from "../data/warnings";

@Component<BoardAction>({
  components: {
    Resource,
    SpecialAction,
  },
})
export default class BoardAction extends Vue {
  @Prop()
  action: BoardActionEnum;

  @Prop()
  transform: string;

  onClick() {
    if (!this.highlighted) {
      return;
    }
    this.$store.dispatch("boardActionClick", this.button);
  }

  get highlighted(): boolean {
    return this.$store.state.context.highlighted.boardActions.has(this.action);
  }

  get recent(): boolean {
    const moves = this.$store.getters.recentCommands;
    return moves.some((c) => c.command == Command.Action && (c.args[0] as BoardActionEnum) === this.action);
  }

  get button() {
    const player = this.$store.state.player?.index ?? this.gameData.currentPlayer;
    return boardActionButton(this.action, this.gameData.player(player));
  }

  get warning(): boolean {
    return enabledButtonWarnings(this.button, this.$store.state.preferences).length > 0;
  }

  get faded() {
    return this.player() != null;
  }

  get planet(): Planet {
    const player = this.player();
    if (player != null && player !== PlayerEnum.Player5) {
      // Player5 is for converted old games
      return factionPlanet(this.gameData.player(player).faction);
    }
    return null;
  }

  private player() {
    return this.gameData.boardActions[this.action];
  }

  get kind() {
    return this.action[0] === "p" ? "power" : "qic";
  }

  get gameData(): Engine {
    return this.$store.state.data;
  }

  get costNumber() {
    return Reward.parse(boardActions[this.action].cost)[0].count;
  }

  boardActions = boardActions;
}
